import React from 'react';
import TemplateImage from './TemplateImage';
import findSize from '../../utils/findSize';
import { Sizes } from '../../utils/types';

// a height or width should be specified for each image
// and corresponding maximum for rows and columns where possible

type SocialPostLayoutProps = {
  sizes: Sizes;
};

export default function SocialPostLayout({ sizes }: SocialPostLayoutProps) {
  return (
    <div className="select-none overflow-hidden p-8">
      <div className="mx-auto flex flex-row justify-end gap-4 overflow-hidden">
        <TemplateImage size={findSize(sizes, 1080, 1080)} height={212} />
        <div className="flex max-h-[226px] max-w-[212px] flex-col items-start gap-4">
          <TemplateImage size={findSize(sizes, 1200, 600)} width={200} />
          <TemplateImage size={findSize(sizes, 1200, 628)} width={210} />
        </div>
      </div>
    </div>
  );
}
